import { Grid, styled } from "@mui/material";

export const Container = styled(Grid)({
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "15px",
  cursor: "pointer",
  fontSize: "2rem",
});
